module.exports = __webpack_public_path__ + "img/productBgImg6.9b3f7aeb.png";